module.exports = __webpack_public_path__ + "img/jf_home_04.1b8f2708.jpg";